import { DoctorOverview } from "@/types";

export const mapToDoctorOverview = (doctor: any): DoctorOverview => ({
  id: doctor.id,
  user_fullname: doctor.user_fullname || doctor.full_name || "Unknown",
  user_email: doctor.user_email || "",
  birthday: doctor.birthday || "",
  user_phone_number: doctor.user_phone_number,
  consultation_fee: doctor.consultation_fee || "0.00",
  blood_group: doctor.blood_group || "",
  years_of_experience: doctor.years_of_experience || "",
  gender: doctor.gender || "",
  address1: doctor.address1 || { country: "", state: "", city: "", pincode: "" },
  address2: doctor.address2,
  medical_license_number: doctor.medical_license_number || "",
  user_status: doctor.user_status || 0,
  department_id: doctor.department_id || { id: 0, department: "" },
  designation_id: doctor.designation_id || { id: 0, designation: "" },
  branch: doctor.branch || { id: 0, name: "", location: "", description: null, status: 0, image_id: null, image: null },
  availabilities: doctor.availabilities || [],
  image: doctor.image || { file_name: "", file_type: "", file_size: 0, file_url: "" },
  next_available_date: doctor.next_available_date,
});